module.exports = __webpack_public_path__ + "static/media/card4.8d37c136.png";